export enum AssociationTypesEnum {
    hasOne,
    hasMany
}